const HTML_ESCAPES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
};

/**
 * Escapes text for an HTML string (element content or a quoted attribute). Required for anything that ends up in an
 * HTML sink (innerHTML, document.write, HTML templates): API responses are entity-decoded in api/request.ts, so
 * server-side escaping does not protect those sinks.
 */
export const escapeHtml = (value: unknown): string => String(value ?? "").replace(/[&<>"']/g, (c) => HTML_ESCAPES[c]);
